import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

// This error is not the same as receiving a 400 or 500 response from the server. It means the request actually failed (e.g. network error).
export const HttpRequestFailedError = BaseErrorSchema.extend({
  errorType: z.literal('HttpRequestFailedError'),
  errorReason: z.string(),
});

export type HttpRequestFailedError = z.infer<typeof HttpRequestFailedError>;
